import '../assets/NcAssistantContent-DrswfkY-.css';
import { n as normalizeComponent } from "../chunks/_plugin-vue2_normalizer-DU4iP6Vu.mjs";
const assistantContent = "_assistantContent_HSz7O";
const assistantContent__inner = "_assistantContent__inner_NqOmP";
const style0 = {
  "material-design-icon": "_material-design-icon_0irai",
  assistantContent,
  assistantContent__inner
};
const _sfc_main = {
  __name: "NcAssistantContent",
  props: {
    /**
     * Classes to assign to the content container
     */
    contentClasses: {
      type: [String, Array, Object],
      default: ""
    }
  },
  setup(__props) {
    return { __sfc: true };
  }
};
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c;
  _vm._self._setupProxy;
  return _c("div", { class: _vm.$style.assistantContent }, [_c("div", { class: [_vm.$style.assistantContent__inner, _vm.contentClasses] }, [_vm._t("default")], 2)]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles,
  null
);
const NcAssistantContent = __component__.exports;
export {
  NcAssistantContent as default
};
//# sourceMappingURL=NcAssistantContent.mjs.map
